import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setCargoConsultaVerbasExerciciosAnteriores: ['cargo'],
    setReferenciaConsultaVerbasExerciciosAnteriores: ['referencia'],
    limpaFiltroConsultaVerbasExerciciosAnteriores: [],
    receberFiltroConsultaVerbasExerciciosAnteriores: ['filtroRecebido'],
    setStatusConsultaVerbasExerciciosAnteriores: ['status'],
})

const mes = String(new Date().getMonth() + 1).padStart(2, '0')
const anoAnterior = new Date().getFullYear() - 1

const INITIAL_STATE = {
    referencia: mes + '/' + anoAnterior,
    cargo: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    if (action.referencia.split('/')[1] >= new Date().getFullYear()) {
        action.referencia = action.referencia.split('/')[0] + '/' + anoAnterior
    }
    return { ...state, referencia: action.referencia }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES]: setReferencia,
    [Types.SET_CARGO_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES]: setStatus,
})
